<template>
  <v-navigation-drawer
    color="primary"
    v-model="drawer"
    app
    clipped
    left
    style="top: 64px; max-height: calc(100% - 64px)"
  >
    <v-list dense dark>
      <v-list-item-group v-model="model" mandatory>
        <router-link
          class="white--text navigation-a-underline--remove"
          :to="{ name: 'tasks' }"
          v-if="getMe.menu_access.tasks.visible"
        >
          <v-list-item link>
            <v-list-item-action>
              <v-icon>mdi-calendar</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{
                $t("components.navigationBar.tasksBar.tasks")
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </router-link>
        <router-link
          class="white--text navigation-a-underline--remove"
          :to="{
            name: 'services',
            query: { crm_boat_uuid: '', page: 1, service_status: 'upcoming' },
          }"
          v-if="getMe.menu_access.services.visible"
        >
          <v-list-item link>
            <v-list-item-action>
              <v-icon>mdi-hammer-wrench</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{
                $t("components.navigationBar.tasksBar.maintenance")
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </router-link>
        <router-link
          class="white--text navigation-a-underline--remove"
          :to="{ name: 'tasksTemplate' }"
          v-if="true"
        >
          <v-list-item link>
            <v-list-item-action>
              <v-icon>mdi-checkbox-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{
                $t("components.navigationBar.tasksBar.checklists")
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </router-link>
      </v-list-item-group>
    </v-list>
    <v-list dense dark v-if="!loading && canUseKnowledgeBaseBtn">
      <v-list-item @click="handleHelp">
        <v-list-item-action>
          <v-icon>mdi-help-circle</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{
            $t("components.navigationBar.tasksBar.help")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <template v-slot:append>
      <powered-by-sentinel :is-navbar="true" />
    </template>
    <help-dialog
      :dialog="helpDialog"
      @close="closeHelpDialog"
      v-if="helpDialog.active"
    ></help-dialog>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { USER_CRM_REQUEST } from "@/store/actions/user";
import HelpDialog from "@/components/dialogs/HelpDialog";
import constraints from "@/utils/constraints";
import PoweredBySentinel from "../banners/PoweredBySentinel.vue";

export default {
  components: {
    HelpDialog,
    PoweredBySentinel,
  },
  data: () => ({
    canUseKnowledgeBaseBtn: false,
    helpDialog: { location: null, active: false },
    drawer: null,
    loading: true,
    model: null,
    drawerStatus: ["tasks", "tasksMaintenance", "tasksTemplates"],
  }),

  created: function () {
    this.canUseKnowledgeBaseBtn = constraints.canUseKnowledgeBaseBtn("tasks");

    if (Object.keys(this.getMe).length === 0) {
      this.$store.dispatch(USER_CRM_REQUEST).then((resp) => {
        this.loading = false;
      });
    } else {
      this.loading = false;
    }

    this.drawerStatus.forEach((element, index) => {
      if (this.subMenuActive(element)) {
        this.model = index;
      }
    });
  },
  mounted() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "COLLAPSED") {
        this.drawer = mutation.payload;
      }
    });
  },

  watch: {
    drawer(val) {
      if (this.getDrawerStatus !== this.drawer) {
        this.$store.commit("COLLAPSED", val);
      }
    },
    $route(val) {
      this.drawerStatus.forEach((element, index) => {
        if (this.subMenuActive(element)) {
          this.model = index;
        }
      });
    },
  },

  methods: {
    closeHelpDialog(event) {
      if (event === "close") {
        this.helpDialog.active = false;
      }
    },
    handleHelp(event) {
      this.helpDialog.active = true;
      this.helpDialog.location = "tasks";
    },
    subMenuActive(input) {
      return this.$route.meta.menu === input;
    },
  },
  computed: {
    ...mapGetters(["getDrawerStatus", "getMe"]),
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
.navigation-a-underline--remove {
  text-decoration: none;
}
</style>
